<template>
  <div :class="`${isShowCheckAnswer?'h-8':'h-0'}`">
    <template v-if="isShowCheckAnswer">
      <div class="w-full box-border px-3 text-right">
        <van-button @click="viewAnswer" size="small" type="primary">查看答案</van-button>
      </div>
    </template>
    <van-popup v-model:show="answerPopShow" position="bottom" :style="{ height: '80%' }">
      <div class="py-4 px-3">
        <div class="title text-20 font-bold mb-3 text-center" v-html="title"></div>
        <div v-for="question in list" :key="question.q_id" class="relative">
          <preview-question :question="question" />
          <div class="absolute inset-0"></div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
  import PreviewQuestion from '@/components/PreviewQuestion'
  import { convertAnswerText } from '@/assets/js/utils'
  import { getSourceAnswer, createQuestionFactory } from 'dygc'

  export default {
    name: 'ViewAnswer',
    components: {PreviewQuestion},
    data() {
      return {
        list: [],
        answerPopShow: false,
        isShowCheckAnswer: false,
        title: ''
      }
    },
    created() {
      const {accountUserId, surveyId, accountUserOpenId} =  this.$bus.params
      getSourceAnswer({
        surveyId,
        accountUserId,
        accountUserOpenId,
        accountUserFingerprint: this.$bus.accountUserFingerprint
      }).then(res=> {
        const d = res.data
        this.isShowCheckAnswer = !!(d?.answerContent)
        this.$emit('update-show-answer', this.isShowCheckAnswer)
        this.title = d?.surveyTitle??''
        this.list = d.answerContent.filter(item=>item.questionDetails).map((item, index) => {
          item.questionDetails = {
            ...item.questionDetails,
            content: {
              ...item.questionDetails.content,
              text: convertAnswerText(item.questionDetails.content.richText || item.questionDetails.content.text, d.answerContent),
              richText: convertAnswerText(item.questionDetails.content.richText || item.questionDetails.content.text, d.answerContent)
            }
          }
          const q = createQuestionFactory(item.questionDetails)
          q.setValue(item)
          q.disabledProgress = true
          q.num = index+1
          return q
        })
        console.log('this.list', this.list)
      })
    },
    methods: {
      viewAnswer() {
        this.answerPopShow = true
      }
    }
  }
</script>